import { useState } from 'react'

import Table from 'components/TableNowrap'
import { Report13ListTableTypes } from 'schemas/reports-#-13-schemas'

const columns = [
  'Transaction',
  'Type',
  'Transaction Date',
  'Processed Date',
  'From',
  'Device Code',
  'To',
  'Refunded Trans ID',
  'Refund Trans ID',
  'Trace No.',
  'Purchase',
  'Loyalty',
  'Credit',
  'Comments',
  'Thor User',
  'Custom1',
  'Custom2',
  'Custom3',
  'Custom4'
]

export const Report13Table = (props: Report13ListTableTypes) => {
  const { tableData } = props
  const [currentPage, setCurrentPage] = useState(1)

  function handlePageClick({ selected }: { selected: number }): void {
    // setLoading(true)
    // setOffset(selected * perPage)
    setCurrentPage(selected + 1)
  }

  return (
    <Table
      data={tableData}
      columns={columns}
      pageCount={0}
      showActions
      currentPage={currentPage}
      perPage={10}
      onPageChange={handlePageClick}
      itemCount={tableData.length}
    >
      {tableData.map((report) => (
        <tr
          key={report.transactionId}
          className="py-2 text-black bg-white cursor-pointer hover:bg-gray-600"
        // redirect to merchant profile
        // onClick={() =>
        //   navigate(
        //     `${ROUTES.Merchant.path}/${report.report_id}/transactions`
        //   )
        // }
        >
          <td className="py-2 pl-6">
            <p>{report.transactionId}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.transactionType}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.transactionDate}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.processedDate}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.fromTraderName}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.deviceCode}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.toTraderName}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.refundedTransactionId || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.refundTransactionId || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.traceNumber}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.purchaseValue}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.loyaltyValue}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.creditValue}</p>
          </td>
          {/* <td className="py-2 pl-6">
            <p>{report.ident}</p>
          </td> */}
          <td className="py-2 pl-6">
            <p>{report.comments || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.login || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.custom1 || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.custom2 || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.custom3 || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.custom4 || '---'}</p>
          </td>
          <td></td>
        </tr>
      ))}
    </Table>
  )
}
